import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Nav } from "reactstrap";
import { Link } from "react-router-dom";
import { Collapse } from "reactstrap";
import Ico from "../../assets/images/icon.png";
import logoName from "../../assets/images/logo_name.png";

import {
  FaDesktop,
  FaCalendarCheck,
  FaAddressBook,
  FaFileAlt,
  FaChevronDown,
  FaCompass,
  FaWrench,
  FaRulerCombined,
  FaGasPump,
  FaClipboardList,
  FaMapMarkedAlt,
  FaCloudRain,
  FaBroadcastTower,
  FaMobileAlt,
  FaInfoCircle,
  FaUserShield,
  FaExclamationTriangle,
} from "react-icons/fa";
import { usePendingSchedules } from "../../contexts/PendingSchedulesContext";
import { usePendingActions } from "../../contexts/PendingActionsContext";
import { usePendingOperatorAccess } from "../../contexts/PendingOperatorAccessContext";
import { usePendingMachineRegistration } from "../../contexts/PendingMachineRegistrationContext";
import { useMaintenanceOverdueCount } from "../../hooks/useMaintenanceOverdueCount";
import SidebarToolInfoModal from "../../components/SidebarToolInfoModal";
import SidebarHelpAssistant from "./SidebarHelpAssistant";
import SidebarStaleMeterAlertsModal from "../../components/SidebarStaleMeterAlertsModal";
import {
  RUMO_PISTA_HELP_TITLE,
  RumoPistaHelpContent,
} from "../RumoPistaAB/rumoPistaHelpContent";
import {
  SERVICE_ORDER_HELP_TITLE,
  ServiceOrderHelpContent,
} from "../PendingSchedules/serviceOrderHelpContent";
import {
  DASHBOARD_HELP_TITLE,
  DashboardHelpContent,
} from "../Dashboard/dashboardHelpContent";
import {
  RADIO_HELP_TITLE,
  RadioHelpContent,
} from "../Radio/radioHelpContent";
import {
  OPERATION_HELP_TITLE,
  OperationHelpContent,
} from "../Operation/operationHelpContent";
import {
  CALIBRATION_CHECK_HELP_TITLE,
  CalibrationCheckHelpContent,
} from "../FieldApp/calibrationCheckHelpContent";
import {
  MACHINE_MAINTENANCE_HELP_TITLE,
  MachineMaintenanceHelpContent,
} from "../FieldApp/machineMaintenanceHelpContent";
import {
  FARM_MAP_HELP_TITLE,
  FarmMapHelpContent,
} from "../FarmMap/farmMapHelpContent";
import {
  FARM_RAIN_HISTORY_HELP_TITLE,
  FarmRainHistoryHelpContent,
} from "../FarmMap/farmRainHistoryHelpContent";
import {
  FIELD_APP_HELP_TITLE,
  FieldAppHelpContent,
} from "../FieldApp/fieldAppHelpContent";
import {
  PENDING_ACTIONS_HELP_TITLE,
  PendingActionsHelpContent,
} from "../FieldApp/pendingActionsHelpContent";
import {
  REGISTRATIONS_HELP_TITLE,
  RegistrationsHelpContent,
} from "./registrationsHelpContent";
import {
  REPORTS_HELP_TITLE,
  ReportsHelpContent,
} from "../Report/reportsHelpContent";
import {
  FUEL_CONTROL_HELP_TITLE,
  FuelControlHelpContent,
} from "../FieldApp/fuelControlHelpContent";
import {
  countPendingByCategory,
  PENDING_ACTION_CATEGORIES,
} from "../FieldApp/pendingActionCategories";

import "./Base.css";

class Sidebar extends Component {
  state = {
    user: [],
    collapseReport: false,
    collapseRegister: false,
    collapsePendingActions: false,
    collapseOperations: false,
    activeOperation: false,
    activePanel: false,
    showRumoPistaHelp: false,
    showServiceOrderHelp: false,
    showDashboardHelp: false,
    showRadioHelp: false,
    showOperationHelp: false,
    showCalibrationHelp: false,
    showMaintenanceHelp: false,
    showFarmMapHelp: false,
    showFarmRainHistoryHelp: false,
    showPendingActionsHelp: false,
    showFieldAppHelp: false,
    showRegistrationsHelp: false,
    showReportsHelp: false,
    showFuelControlHelp: false,
    showStaleMeterAlerts: false,
  };

  componentDidMount() {
    if (localStorage.getItem("client") !== null) {
      this.setState({
        user: JSON.parse(localStorage.getItem("client")),
      });
    } else {
      // console.log(localStorage.getItem("client"));
      setTimeout(() => {
        this.setState({
          user: JSON.parse(localStorage.getItem("client")),
        });
      }, 2000);
    }

    const search = this.props.location && this.props.location.search;
    if (search && search.indexOf("tab=pending-actions") >= 0) {
      this.setState({ collapsePendingActions: true });
    }
    if (
      this.props.location &&
      this.props.location.pathname.indexOf("/operation/") >= 0
    ) {
      this.setState({ collapseOperations: true });
    }
    if (
      window.location.pathname.indexOf(`/${this.props.farm_id}/operator`) ===
        0 ||
      window.location.pathname.indexOf(
        `/${this.props.farm_id}/equipment`
      ) === 0
    ) {
      this.setState({ collapseRegister: true });
    }
  }

  componentDidUpdate(prevProps) {
    const search = this.props.location && this.props.location.search;
    const prevSearch = prevProps.location && prevProps.location.search;
    const pathname = this.props.location && this.props.location.pathname;
    const prevPathname = prevProps.location && prevProps.location.pathname;
    if (
      search &&
      search !== prevSearch &&
      search.indexOf("tab=pending-actions") >= 0 &&
      !this.state.collapsePendingActions
    ) {
      this.setState({ collapsePendingActions: true });
    }
    if (
      pathname &&
      pathname !== prevPathname &&
      pathname.indexOf("/operation/") >= 0 &&
      !this.state.collapseOperations
    ) {
      this.setState({ collapseOperations: true });
    }
  }

  render() {
    const {
      user,
      collapseRegister,
      collapseReport,
      collapsePendingActions,
      collapseOperations,
      activeOperation,
      activePanel,
    } = this.state;

    let farm_id = this.props.farm_id;
    const location = window.location;

    if (user.length === 0) return false;

    return (
      <>
        <div className="col-md-3 left_col fixed menu_fixed">
          <div className="left_col">
            <div className="navbar nav_title " style={{ border: 0 }}>
              <Link to={`/${farm_id}`} className="site_title">
                <img
                  src={Ico}
                  alt="Home"
                  style={{ height: "85%" }}
                  align="center"
                />
                <img src={logoName} style={{ width: "150px" }} alt="Home" />
              </Link>
            </div>

            <div className="clearfix"></div>

            <SidebarHelpAssistant />

            <div className="profile clearfix">
              <div className="profile_pic">
                <img
                  src={user.thumbnail}
                  className="img-circle profile_img"
                  alt=""
                />
              </div>

              <div className="profile_info">
                <span>{this.props.t("Bem vindo")}</span>
                <h2>
                  {user.first_name} {user.last_name}
                </h2>
              </div>
            </div>

            <div
              id="sidebar-menu"
              className="main_menu_side hidden-print main_menu"
            >
              <div className="menu_section">
                <Nav>
                  <ul className="nav side-menu">
                    <li
                      onClick={() =>
                        this.setState({
                          activePanel: !activePanel,
                          activeOperation:
                            activeOperation === true ? false : activeOperation,
                        })
                      }
                      className={
                        location.pathname === `/${farm_id}/`
                          ? "current-page"
                          : ""
                      }
                    >
                      <Link to={`/${farm_id}/`}>
                        <FaDesktop color="#E7E7E7" />
                        <span className="span"></span>
                        <span>{this.props.t("Painel")}</span>
                        <span
                          role="button"
                          tabIndex={0}
                          className="sidebar-menu-info-btn"
                          title={this.props.t("Como usar o painel?")}
                          aria-label={this.props.t("Como usar o painel?")}
                          onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            this.setState({ showDashboardHelp: true });
                          }}
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              event.stopPropagation();
                              this.setState({ showDashboardHelp: true });
                            }
                          }}
                        >
                          <FaInfoCircle />
                        </span>
                      </Link>
                    </li>

                    <li
                      className={
                        location.pathname.indexOf(`/${farm_id}/radio/`) === 0
                          ? "current-page"
                          : ""
                      }
                    >
                      <Link to={`/${farm_id}/radio/`}>
                        <FaBroadcastTower color="#E7E7E7" />
                        <span className="span"></span>
                        <span>{this.props.t("Rádio")}</span>
                        <span
                          role="button"
                          tabIndex={0}
                          className="sidebar-menu-info-btn"
                          title={this.props.t("Como usar o rádio?")}
                          aria-label={this.props.t("Como usar o rádio?")}
                          onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            this.setState({ showRadioHelp: true });
                          }}
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              event.stopPropagation();
                              this.setState({ showRadioHelp: true });
                            }
                          }}
                        >
                          <FaInfoCircle />
                        </span>
                      </Link>
                    </li>

                    <li
                      className={
                        location.pathname.indexOf(`/${farm_id}/field-app/`) ===
                        0
                          ? "current-page"
                          : ""
                      }
                    >
                      <Link to={`/${farm_id}/field-app/`}>
                        <FaMobileAlt color="#E7E7E7" />
                        <span className="span"></span>
                        <span>{this.props.t("App de Campo")}</span>
                        <span
                          role="button"
                          tabIndex={0}
                          className="sidebar-menu-info-btn"
                          title={this.props.t("Como usar o App de Campo?")}
                          aria-label={this.props.t("Como usar o App de Campo?")}
                          onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            this.setState({ showFieldAppHelp: true });
                          }}
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              event.stopPropagation();
                              this.setState({ showFieldAppHelp: true });
                            }
                          }}
                        >
                          <FaInfoCircle />
                        </span>
                      </Link>
                    </li>

                    <li
                      onClick={() =>
                        this.setState({
                          collapseOperations: !collapseOperations,
                        })
                      }
                      className={
                        collapseOperations === true ||
                        location.pathname.indexOf(`/${farm_id}/operation/`) ===
                          0
                          ? "current-page"
                          : ""
                      }
                    >
                      <a>
                        <FaCalendarCheck />
                        <span className="span"></span>
                        <span>{this.props.t("Máquinas e Operações")}</span>
                        {this.props.staleMeterAlertsCount > 0 ? (
                          <button
                            type="button"
                            className="sidebar-pending-badge sidebar-pending-badge-btn"
                            title={this.props.t(
                              "Alertas de hodômetro/horímetro possivelmente com defeito — clique para ver"
                            )}
                            aria-label={this.props.t(
                              "Ver alertas de hodômetro/horímetro ({{count}})",
                              { count: this.props.staleMeterAlertsCount }
                            )}
                            onClick={(event) => {
                              event.preventDefault();
                              event.stopPropagation();
                              this.setState({ showStaleMeterAlerts: true });
                            }}
                          >
                            {this.props.staleMeterAlertsCount > 99
                              ? "99+"
                              : this.props.staleMeterAlertsCount}
                          </button>
                        ) : null}
                        <span
                          role="button"
                          tabIndex={0}
                          className="sidebar-menu-info-btn"
                          title={this.props.t("Como funcionam as operações?")}
                          aria-label={this.props.t(
                            "Como funcionam as operações?"
                          )}
                          onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            this.setState({ showOperationHelp: true });
                          }}
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              event.stopPropagation();
                              this.setState({ showOperationHelp: true });
                            }
                          }}
                        >
                          <FaInfoCircle />
                        </span>
                        <FaChevronDown />
                      </a>

                      <Collapse isOpen={collapseOperations}>
                        <ul
                          className="nav child_menu"
                          style={{
                            display: "block",
                          }}
                        >
                          <li
                            className={
                              location.pathname === `/${farm_id}/operation/` ||
                              (location.pathname.indexOf(
                                `/${farm_id}/operation/`
                              ) === 0 &&
                                location.pathname.indexOf(
                                  "/fleet-summary"
                                ) < 0 &&
                                !location.pathname.match(
                                  /\/operation\/[^/]+$/
                                ))
                                ? "current-page"
                                : undefined
                            }
                          >
                            <Link to={`/${farm_id}/operation/`}>
                              <span>{this.props.t("Lista de operações")}</span>
                            </Link>
                          </li>
                          <li
                            className={
                              location.pathname.indexOf(
                                `/${farm_id}/operation/fleet-summary`
                              ) === 0
                                ? "current-page"
                                : undefined
                            }
                          >
                            <Link to={`/${farm_id}/operation/fleet-summary`}>
                              <span>
                                {this.props.t("Resumo das máquinas")}
                              </span>
                            </Link>
                          </li>
                        </ul>
                      </Collapse>
                    </li>

                    <li
                      className={
                        location.pathname.indexOf(
                          `/${farm_id}/pending-schedules/`
                        ) === 0
                          ? "current-page"
                          : ""
                      }
                    >
                      <Link to={`/${farm_id}/pending-schedules/`}>
                        <FaClipboardList color="#E7E7E7" />
                        <span className="span"></span>
                        <span>{this.props.t("Ordens de Serviço")}</span>
                        <span
                          role="button"
                          tabIndex={0}
                          className="sidebar-menu-info-btn"
                          title={this.props.t("Como funcionam as ordens de serviço?")}
                          aria-label={this.props.t(
                            "Como funcionam as ordens de serviço?"
                          )}
                          onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            this.setState({ showServiceOrderHelp: true });
                          }}
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              event.stopPropagation();
                              this.setState({ showServiceOrderHelp: true });
                            }
                          }}
                        >
                          <FaInfoCircle />
                        </span>
                        {this.props.pendingCount > 0 && (
                          <span className="sidebar-pending-badge">
                            {this.props.pendingCount > 99
                              ? "99+"
                              : this.props.pendingCount}
                          </span>
                        )}
                      </Link>
                    </li>

                    <li
                      className={
                        location.pathname.indexOf(`/${farm_id}/farm-map/`) === 0
                          ? "current-page"
                          : ""
                      }
                    >
                      <Link to={`/${farm_id}/farm-map/`}>
                        <FaMapMarkedAlt color="#E7E7E7" />
                        <span className="span"></span>
                        <span>{this.props.t("Mapa da fazenda")}</span>
                        <span
                          role="button"
                          tabIndex={0}
                          className="sidebar-menu-info-btn"
                          title={this.props.t("O que é esta ferramenta?")}
                          aria-label={this.props.t("O que é esta ferramenta?")}
                          onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            this.setState({ showFarmMapHelp: true });
                          }}
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              event.stopPropagation();
                              this.setState({ showFarmMapHelp: true });
                            }
                          }}
                        >
                          <FaInfoCircle />
                        </span>
                      </Link>
                    </li>

                    <li
                      className={
                        location.pathname.indexOf(
                          `/${farm_id}/historico-chuva/`
                        ) === 0
                          ? "current-page"
                          : ""
                      }
                    >
                      <Link to={`/${farm_id}/historico-chuva/`}>
                        <FaCloudRain color="#E7E7E7" />
                        <span className="span"></span>
                        <span>
                          {this.props.t("Histórico de chuva e clima")}
                        </span>
                        <span
                          role="button"
                          tabIndex={0}
                          className="sidebar-menu-info-btn"
                          title={this.props.t("Como funciona o histórico de chuva?")}
                          aria-label={this.props.t(
                            "Como funciona o histórico de chuva?"
                          )}
                          onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            this.setState({ showFarmRainHistoryHelp: true });
                          }}
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              event.stopPropagation();
                              this.setState({ showFarmRainHistoryHelp: true });
                            }
                          }}
                        >
                          <FaInfoCircle />
                        </span>
                      </Link>
                    </li>

                    <li
                      onClick={() =>
                        this.setState({
                          collapseRegister: !collapseRegister,
                        })
                      }
                      className={
                        collapseRegister === true ||
                        location.pathname.indexOf(`/${farm_id}/equipment/`) ===
                          0 ||
                        location.pathname.indexOf(`/${farm_id}/fuel-pump`) ===
                          0 ||
                        location.pathname.indexOf(`/${farm_id}/operator`) ===
                          0 ||
                        location.pathname.indexOf(`/${farm_id}/service-farms`) ===
                          0 ||
                        location.pathname.indexOf(`/${farm_id}/landplots`) === 0 ||
                        location.pathname.indexOf(`/${farm_id}/platform-access`) ===
                          0
                          ? "current-page"
                          : ""
                      }
                    >
                      <a>
                        <FaAddressBook />
                        <span className="span"></span>
                        <span>{this.props.t("Cadastros")}</span>
                        {this.props.registrationsAlertCount > 0 ? (
                          <span
                            className="sidebar-pending-badge"
                            title={this.props.t(
                              "{{count}} pendência(s) em cadastros",
                              {
                                count: this.props.registrationsAlertCount,
                              }
                            )}
                          >
                            {this.props.registrationsAlertCount > 99
                              ? "99+"
                              : this.props.registrationsAlertCount}
                          </span>
                        ) : null}
                        <span
                          role="button"
                          tabIndex={0}
                          className="sidebar-menu-info-btn"
                          title={this.props.t("Para que servem os cadastros?")}
                          aria-label={this.props.t(
                            "Para que servem os cadastros?"
                          )}
                          onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            this.setState({ showRegistrationsHelp: true });
                          }}
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              event.stopPropagation();
                              this.setState({ showRegistrationsHelp: true });
                            }
                          }}
                        >
                          <FaInfoCircle />
                        </span>
                        <FaChevronDown />
                      </a>

                      <Collapse isOpen={collapseRegister}>
                        <ul
                          className="nav child_menu"
                          style={{
                            display: "block",
                          }}
                        >
                          <li>
                            <Link to={`/${farm_id}/equipment/machine/`}>
                              <span>{this.props.t("Máquinas")}</span>
                              {collapseRegister &&
                              this.props.pendingMachineRegistrationCount >
                                0 ? (
                                <span
                                  className="sidebar-pending-badge sidebar-pending-badge--child"
                                  title={this.props.t(
                                    "{{count}} máquina(s) com cadastro pendente",
                                    {
                                      count: this.props
                                        .pendingMachineRegistrationCount,
                                    }
                                  )}
                                >
                                  {this.props
                                    .pendingMachineRegistrationCount > 99
                                    ? "99+"
                                    : this.props
                                        .pendingMachineRegistrationCount}
                                </span>
                              ) : null}
                            </Link>
                          </li>
                          <li>
                            <Link to={`/${farm_id}/fuel-pump/`}>
                              <span>
                                {this.props.t("Bombas de Combustível")}
                              </span>
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={
                                this.props.pendingOperatorAccessCount > 0
                                  ? `/${farm_id}/operator/?acesso=pendente`
                                  : `/${farm_id}/operator/`
                              }
                            >
                              <span>{this.props.t("Operadores")}</span>
                              {collapseRegister &&
                              this.props.pendingOperatorAccessCount > 0 ? (
                                <span className="sidebar-pending-badge sidebar-pending-badge--child">
                                  {this.props.pendingOperatorAccessCount > 99
                                    ? "99+"
                                    : this.props.pendingOperatorAccessCount}
                                </span>
                              ) : null}
                            </Link>
                          </li>
                          <li>
                            <Link to={`/${farm_id}/service-farms/`}>
                              <span>{this.props.t("Sub-fazendas")}</span>
                            </Link>
                          </li>
                          <li>
                            <Link to={`/${farm_id}/platform-access/`}>
                              <FaUserShield style={{ marginRight: 6 }} />
                              <span>
                                {this.props.t("Cadastro de Administradores")}
                              </span>
                            </Link>
                          </li>
                        </ul>
                      </Collapse>
                    </li>

                    <li
                      onClick={() =>
                        this.setState({
                          collapseReport: !collapseReport,
                        })
                      }
                      className={
                        collapseReport === true ||
                        location.pathname.indexOf(`/${farm_id}/report/`) === 0
                          ? "current-page"
                          : ""
                      }
                    >
                      <a>
                        <FaFileAlt />
                        <span className="span"></span>
                        <span>{this.props.t("Relatórios")}</span>
                        <span
                          role="button"
                          tabIndex={0}
                          className="sidebar-menu-info-btn"
                          title={this.props.t("Para que servem os relatórios?")}
                          aria-label={this.props.t(
                            "Para que servem os relatórios?"
                          )}
                          onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            this.setState({ showReportsHelp: true });
                          }}
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              event.stopPropagation();
                              this.setState({ showReportsHelp: true });
                            }
                          }}
                        >
                          <FaInfoCircle />
                        </span>
                        <FaChevronDown />
                      </a>

                      <Collapse isOpen={collapseReport}>
                        <ul
                          className="nav child_menu"
                          style={{
                            display: "block",
                          }}
                        >
                          <li>
                            <Link to={`/${farm_id}/report/fleet/`}>
                              <span>{this.props.t("Máquinas")}</span>
                            </Link>
                          </li>
                          <li>
                            <Link to={`/${farm_id}/report/section/`}>
                              <span>{this.props.t("Por seção")}</span>
                            </Link>
                          </li>
                        </ul>
                      </Collapse>
                    </li>

                    <li
                      className={
                        location.pathname.indexOf(
                          `/${farm_id}/rumo-pista-ab/`
                        ) === 0
                          ? "current-page"
                          : undefined
                      }
                    >
                      <Link to={`/${farm_id}/rumo-pista-ab/`}>
                        <FaCompass />
                        <span className="span"></span>
                        <span>{this.props.t("Rumo de Pista A-B")}</span>
                        <span
                          role="button"
                          tabIndex={0}
                          className="sidebar-menu-info-btn"
                          title={this.props.t("O que é esta ferramenta?")}
                          aria-label={this.props.t("O que é esta ferramenta?")}
                          onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            this.setState({ showRumoPistaHelp: true });
                          }}
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              event.stopPropagation();
                              this.setState({ showRumoPistaHelp: true });
                            }
                          }}
                        >
                          <FaInfoCircle />
                        </span>
                      </Link>
                    </li>

                    <li
                      className={
                        location.pathname.indexOf(`/${farm_id}/field-app/`) ===
                          0 &&
                        location.search.indexOf("tab=maintenance") >= 0
                          ? "current-page"
                          : undefined
                      }
                    >
                      <Link to={`/${farm_id}/field-app/?tab=maintenance`}>
                        <FaWrench />
                        <span className="span"></span>
                        <span>{this.props.t("Manutenção")}</span>
                        {this.props.maintenanceOverdueCount > 0 ? (
                          <span
                            className="sidebar-pending-badge"
                            title={this.props.t(
                              "Manutenções vencidas por horímetro"
                            )}
                          >
                            {this.props.maintenanceOverdueCount > 99
                              ? "99+"
                              : this.props.maintenanceOverdueCount}
                          </span>
                        ) : null}
                        <span
                          role="button"
                          tabIndex={0}
                          className="sidebar-menu-info-btn"
                          title={this.props.t("O que é esta ferramenta?")}
                          aria-label={this.props.t("O que é esta ferramenta?")}
                          onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            this.setState({ showMaintenanceHelp: true });
                          }}
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              event.stopPropagation();
                              this.setState({ showMaintenanceHelp: true });
                            }
                          }}
                        >
                          <FaInfoCircle />
                        </span>
                      </Link>
                    </li>

                    <li
                      className={
                        location.pathname.indexOf(`/${farm_id}/field-app/`) ===
                          0 &&
                        location.search.indexOf("tab=calibration") >= 0
                          ? "current-page"
                          : undefined
                      }
                    >
                      <Link to={`/${farm_id}/field-app/?tab=calibration`}>
                        <FaRulerCombined />
                        <span className="span"></span>
                        <span>{this.props.t("Check de calibragem")}</span>
                        <span
                          role="button"
                          tabIndex={0}
                          className="sidebar-menu-info-btn"
                          title={this.props.t("O que é esta ferramenta?")}
                          aria-label={this.props.t("O que é esta ferramenta?")}
                          onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            this.setState({ showCalibrationHelp: true });
                          }}
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              event.stopPropagation();
                              this.setState({ showCalibrationHelp: true });
                            }
                          }}
                        >
                          <FaInfoCircle />
                        </span>
                      </Link>
                    </li>

                    <li
                      className={
                        location.pathname.indexOf(`/${farm_id}/field-app/`) ===
                          0 &&
                        location.search.indexOf("tab=fueling") >= 0
                          ? "current-page"
                          : undefined
                      }
                    >
                      <Link to={`/${farm_id}/field-app/?tab=fueling`}>
                        <FaGasPump />
                        <span className="span"></span>
                        <span>{this.props.t("Controle de combustível")}</span>
                        <span
                          role="button"
                          tabIndex={0}
                          className="sidebar-menu-info-btn"
                          title={this.props.t(
                            "Para que serve o controle de combustível?"
                          )}
                          aria-label={this.props.t(
                            "Para que serve o controle de combustível?"
                          )}
                          onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            this.setState({ showFuelControlHelp: true });
                          }}
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              event.stopPropagation();
                              this.setState({ showFuelControlHelp: true });
                            }
                          }}
                        >
                          <FaInfoCircle />
                        </span>
                      </Link>
                    </li>

                    <li
                      onClick={() =>
                        this.setState({
                          collapsePendingActions: !collapsePendingActions,
                        })
                      }
                      className={
                        collapsePendingActions === true ||
                        (location.pathname.indexOf(`/${farm_id}/field-app/`) ===
                          0 &&
                          location.search.indexOf("tab=pending-actions") >= 0)
                          ? "current-page"
                          : undefined
                      }
                    >
                      <a>
                        <FaExclamationTriangle color="#E7E7E7" />
                        <span className="span"></span>
                        <span>{this.props.t("Ações pendentes e alertas")}</span>
                        {this.props.pendingActionsCount > 0 && (
                          <span className="sidebar-pending-badge">
                            {this.props.pendingActionsCount > 99
                              ? "99+"
                              : this.props.pendingActionsCount}
                          </span>
                        )}
                        <span
                          role="button"
                          tabIndex={0}
                          className="sidebar-menu-info-btn"
                          title={this.props.t(
                            "O que são ações pendentes e alertas?"
                          )}
                          aria-label={this.props.t(
                            "O que são ações pendentes e alertas?"
                          )}
                          onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            this.setState({ showPendingActionsHelp: true });
                          }}
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              event.stopPropagation();
                              this.setState({ showPendingActionsHelp: true });
                            }
                          }}
                        >
                          <FaInfoCircle />
                        </span>
                        <FaChevronDown />
                      </a>

                      <Collapse isOpen={collapsePendingActions}>
                        <ul
                          className="nav child_menu"
                          style={{
                            display: "block",
                          }}
                        >
                            {PENDING_ACTION_CATEGORIES.map((category) => {
                            const count = countPendingByCategory(
                              this.props.pendingActionItems,
                              category.id,
                              farm_id
                            );
                            if (
                              category.id !== "all" &&
                              category.id !== "speed_violation" &&
                              count <= 0
                            ) {
                              return null;
                            }
                            const href =
                              category.id === "all"
                                ? `/${farm_id}/field-app/?tab=pending-actions`
                                : `/${farm_id}/field-app/?tab=pending-actions&alert=${category.id}`;
                            const isActive =
                              location.pathname.indexOf(
                                `/${farm_id}/field-app/`
                              ) === 0 &&
                              location.search.indexOf("tab=pending-actions") >=
                                0 &&
                              (category.id === "all"
                                ? location.search.indexOf("alert=") < 0
                                : location.search.indexOf(
                                    `alert=${category.id}`
                                  ) >= 0);
                            return (
                              <li
                                key={category.id}
                                className={isActive ? "current-page" : undefined}
                              >
                                <Link to={href}>
                                  <span>{this.props.t(category.label)}</span>
                                  {count > 0 ? (
                                    <span className="sidebar-pending-badge sidebar-pending-badge--child">
                                      {count > 99 ? "99+" : count}
                                    </span>
                                  ) : null}
                                </Link>
                              </li>
                            );
                          })}
                        </ul>
                      </Collapse>
                    </li>
                  </ul>
                </Nav>
              </div>
            </div>
          </div>
        </div>
        {this.state.showRumoPistaHelp && (
          <SidebarToolInfoModal
            title={this.props.t(RUMO_PISTA_HELP_TITLE)}
            onClose={() => this.setState({ showRumoPistaHelp: false })}
          >
            <RumoPistaHelpContent />
          </SidebarToolInfoModal>
        )}
        {this.state.showServiceOrderHelp && (
          <SidebarToolInfoModal
            title={this.props.t(SERVICE_ORDER_HELP_TITLE)}
            onClose={() => this.setState({ showServiceOrderHelp: false })}
          >
            <ServiceOrderHelpContent />
          </SidebarToolInfoModal>
        )}
        {this.state.showDashboardHelp && (
          <SidebarToolInfoModal
            title={this.props.t(DASHBOARD_HELP_TITLE)}
            onClose={() => this.setState({ showDashboardHelp: false })}
          >
            <DashboardHelpContent />
          </SidebarToolInfoModal>
        )}
        {this.state.showRadioHelp && (
          <SidebarToolInfoModal
            title={this.props.t(RADIO_HELP_TITLE)}
            onClose={() => this.setState({ showRadioHelp: false })}
          >
            <RadioHelpContent />
          </SidebarToolInfoModal>
        )}
        {this.state.showOperationHelp && (
          <SidebarToolInfoModal
            title={this.props.t(OPERATION_HELP_TITLE)}
            onClose={() => this.setState({ showOperationHelp: false })}
          >
            <OperationHelpContent />
          </SidebarToolInfoModal>
        )}
        {this.state.showCalibrationHelp && (
          <SidebarToolInfoModal
            title={this.props.t(CALIBRATION_CHECK_HELP_TITLE)}
            onClose={() => this.setState({ showCalibrationHelp: false })}
          >
            <CalibrationCheckHelpContent />
          </SidebarToolInfoModal>
        )}
        {this.state.showMaintenanceHelp && (
          <SidebarToolInfoModal
            title={this.props.t(MACHINE_MAINTENANCE_HELP_TITLE)}
            onClose={() => this.setState({ showMaintenanceHelp: false })}
          >
            <MachineMaintenanceHelpContent />
          </SidebarToolInfoModal>
        )}
        {this.state.showFarmMapHelp && (
          <SidebarToolInfoModal
            title={this.props.t(FARM_MAP_HELP_TITLE)}
            onClose={() => this.setState({ showFarmMapHelp: false })}
          >
            <FarmMapHelpContent />
          </SidebarToolInfoModal>
        )}
        {this.state.showFarmRainHistoryHelp && (
          <SidebarToolInfoModal
            title={this.props.t(FARM_RAIN_HISTORY_HELP_TITLE)}
            onClose={() => this.setState({ showFarmRainHistoryHelp: false })}
          >
            <FarmRainHistoryHelpContent />
          </SidebarToolInfoModal>
        )}
        {this.state.showPendingActionsHelp && (
          <SidebarToolInfoModal
            title={this.props.t(PENDING_ACTIONS_HELP_TITLE)}
            onClose={() => this.setState({ showPendingActionsHelp: false })}
          >
            <PendingActionsHelpContent />
          </SidebarToolInfoModal>
        )}
        {this.state.showFieldAppHelp && (
          <SidebarToolInfoModal
            title={this.props.t(FIELD_APP_HELP_TITLE)}
            onClose={() => this.setState({ showFieldAppHelp: false })}
          >
            <FieldAppHelpContent />
          </SidebarToolInfoModal>
        )}
        {this.state.showRegistrationsHelp && (
          <SidebarToolInfoModal
            title={this.props.t(REGISTRATIONS_HELP_TITLE)}
            onClose={() => this.setState({ showRegistrationsHelp: false })}
          >
            <RegistrationsHelpContent />
          </SidebarToolInfoModal>
        )}
        {this.state.showReportsHelp && (
          <SidebarToolInfoModal
            title={this.props.t(REPORTS_HELP_TITLE)}
            onClose={() => this.setState({ showReportsHelp: false })}
          >
            <ReportsHelpContent />
          </SidebarToolInfoModal>
        )}
        {this.state.showFuelControlHelp && (
          <SidebarToolInfoModal
            title={this.props.t(FUEL_CONTROL_HELP_TITLE)}
            onClose={() => this.setState({ showFuelControlHelp: false })}
          >
            <FuelControlHelpContent />
          </SidebarToolInfoModal>
        )}
        {this.state.showStaleMeterAlerts && (
          <SidebarStaleMeterAlertsModal
            farmId={farm_id}
            items={this.props.staleMeterAlertItems}
            t={this.props.t}
            onClose={() => this.setState({ showStaleMeterAlerts: false })}
          />
        )}
      </>
    );
  }
}
function SidebarWithBadge(props) {
  const { pendingObs } = usePendingSchedules();
  const { pendingCount: pendingActionsCount, pendingItems } = usePendingActions();
  const { pendingCount: pendingOperatorAccessCount } =
    usePendingOperatorAccess();
  const { pendingCount: pendingMachineRegistrationCount } =
    usePendingMachineRegistration();
  const registrationsAlertCount =
    (pendingOperatorAccessCount || 0) +
    (pendingMachineRegistrationCount || 0);
  const farmId =
    props.farm_id != null
      ? props.farm_id
      : props.match && props.match.params && props.match.params.farm_id;
  const { count: maintenanceOverdueFromApi } = useMaintenanceOverdueCount(farmId);
  const staleMeterAlertItems = React.useMemo(
    () =>
      (pendingItems || []).filter(
        (item) =>
          item.actionType === "stale_meter_reading" &&
          farmId != null &&
          String(item.farmId) === String(farmId)
      ),
    [pendingItems, farmId]
  );
  const staleMeterAlertsCount = staleMeterAlertItems.length;
  const maintenanceOverdueFromPending = React.useMemo(
    () =>
      (pendingItems || []).filter(
        (item) =>
          item.actionType === "maintenance_overdue" &&
          farmId != null &&
          String(item.farmId) === String(farmId)
      ).length,
    [pendingItems, farmId]
  );
  const maintenanceOverdueCount = Math.max(
    maintenanceOverdueFromApi,
    maintenanceOverdueFromPending
  );
  const farmPendingActionsCount = React.useMemo(
    () =>
      farmId != null
        ? (pendingItems || []).filter(
            (item) => String(item.farmId) === String(farmId)
          ).length
        : pendingActionsCount,
    [pendingItems, farmId, pendingActionsCount]
  );
  return (
    <Sidebar
      {...props}
      pendingCount={pendingObs.length}
      pendingOperatorAccessCount={pendingOperatorAccessCount}
      pendingMachineRegistrationCount={pendingMachineRegistrationCount || 0}
      registrationsAlertCount={registrationsAlertCount}
      pendingActionsCount={farmPendingActionsCount}
      pendingActionItems={pendingItems}
      staleMeterAlertsCount={staleMeterAlertsCount}
      staleMeterAlertItems={staleMeterAlertItems}
      maintenanceOverdueCount={maintenanceOverdueCount}
    />
  );
}

export default withTranslation()(SidebarWithBadge);
